import React from "react";
import PrescriptionPreview from "./PrescriptionPreview";
import { motion } from "framer-motion";

const PrescriptionHistory = ({ prescriptions, onDateChange, onBackClick, selectedDate }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-6xl mx-auto px-4 py-6"
    >
      {/* Top Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center mb-8 mt-6">
        {/* Date Picker */}
        <div className="flex justify-start">
          <input
            type="date"
            value={selectedDate}
            onChange={onDateChange}
            className="w-full md:w-auto border border-emerald-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-emerald-400"
          />
        </div>

        {/* Heading */}
        <div className="flex justify-center">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-emerald-700 text-center">
            🩺 Prescription History
          </h1>
        </div>

        {/* Back Button */}
        <div className="flex justify-end">
          <button
            onClick={onBackClick}
            className="w-full md:w-auto bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white py-2 px-4 rounded-md shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
          >
            ⬅️ Back to Patients
          </button>
        </div>
      </div>

      {/* Prescription List */}
      {prescriptions.length === 0 ? (
        <p className="text-center text-gray-600 text-base md:text-lg">
          No prescriptions available.
        </p>
      ) : (
        prescriptions.map((prescription, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
            className="mb-10 bg-white shadow-lg rounded-2xl p-5 sm:p-6 border border-emerald-100 hover:shadow-xl transition-all duration-300"
          >
            <PrescriptionPreview
              patientName={prescription.patientName}
              date={prescription.date}
              symptoms={prescription.symptoms}
              diagnosis={prescription.diagnosis}
              medicines={prescription.medicines}
              labTests={prescription.labTests}
              sos={prescription.sos}
              notes={prescription.notes}
              nextAppointment={prescription.nextAppointment}
            />
          </motion.div>
        ))
      )}
    </motion.div>
  );
};

export default PrescriptionHistory;
